<div class="flex flex-col gap-2">
    <div class="flex flex-row gap-2 items-center pt-2 border-slate-300 border-t">
        <div class="w-[4ch] flex justify-center items-center">
            @if (!showMore) {
                <button (click)="showMore = true">
                    <svg-icon [svgIcon]="showMoreIcon" class="fill-none stroke-slate-600"></svg-icon>
                </button>
            }
        </div>
        <div class="w-[24ch]">
            {{ productName }}
        </div>
        <div class="w-[8ch] flex justify-center">
            <div class="w-[10ch] p-1 text-center text-white rounded shadow-sm cursor-default" [style.background]="statusBadgeColor" title="{{ statusBadgeDescription }}">
                {{ statusBadgeLabel }}
            </div>
        </div>
        <div class="grow flex flex-row gap-2 items-center justify-center">
            @if (canCancel && !isConfirmingCancellation && !isCancelling) {
                <button (click)="onCancelClicked()" class="w-[10ch] p-1 bg-slate-100 rounded shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="isCancelling">
                    Cancel
                </button>
            } @else if (canRenew) {
                <button (click)="onRenewClicked()" class="w-[10ch] p-1 bg-slate-100 rounded shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent" [disabled]="isRenewing">
                    @if (!isRenewing) {
                        Renew
                    } @else {
                        <busy-spin [small]="true"></busy-spin>
                    }
                </button>
            } @else {
                <div class="w-[10ch] p-1 text-slate-400 text-center">
                    
                </div>
            }
        </div>
    </div>
    @if (isConfirmingCancellation || isCancelling) {
        <div class="flex flex-col gap-4 bg-slate-100 rounded shadow p-2 text-justify">
            <p class="text-xs sm:text-sm">Are you sure you wish to cancel this subscription?</p>
            <p class="text-xs sm:text-sm">Once cancelled, you will continue to receive the benefits up until the end of the current billing cycle. You may renew the subscription until that time. At the end of the billing cycle this subscription will be permanently disabled and a new subscription will be needed.</p>
            <p class="text-xs sm:text-sm font-bold">Cancel your "{{ productName }}" subscription?</p>
            <div class="flex flex-row justify-end gap-2">
                <button (click)="onNevermindCancelClicked()" class="w-[10ch] p-2 rounded-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50 hover:shadow-sm disabled:hidden" [disabled]="isCancelling">
                    Nevermind
                </button>
                <button (click)="onConfirmCancelClicked()" class="w-[10ch] p-2 bg-red-500 text-white rounded shadow-sm hover:bg-red-600 disabled:bg-slate-200" [disabled]="isCancelling">
                    @if (!isCancelling) {
                        Confirm
                    } @else {
                        <busy-spin [small]="true"></busy-spin>
                    }
                </button>
            </div>
        </div>
    } @else {
        @if (showMore) {
            <div class="flex flex-col gap-1 text-xs text-slate-500 font-mono">
                <p>ID: {{ subscription.id }}</p>
                <p>Started: <span title="{{ subscription.startedAt }}" [title]="subscription.startedAt">{{ subscription.startedAt | date }}</span></p>
                <p>Ended: <span title="{{ subscription.endedAt }}" [title]="subscription.endedAt">{{ (subscription.endedAt ? (subscription.endedAt | date) : "Active") }}</span></p>
            </div>
        }
    }
    @if (actionError) {
        <div class="flex flex-col gap-2 border border-red-600 rounded p-2 text-red-600 text-xs">
            <p>Uh oh! Something went wrong! Please try again in a few minutes. If this issue persists, <a class="text-red-500 hover:text-red-400" href="/about#contact">please contact us.</a></p>
        </div>
    }
</div>